import get from 'lodash/get';

const selectRewardState = state => get(state, 'reward');
export const selectRewards = state => selectRewardState(state).data;
export const selectGetRewardsStatus = state =>
  selectRewardState(state).getRewards;
